import { useQuery } from '@moonpig/web-core-graphql'
import { useMemo } from 'react'
import { MoreLikeThisQuery } from './__generated__/moreLikeThis'
import { MoreLikeThisGQL } from './moreLikeThis'
import { ProductInfoProduct, SearchCriteria } from '../../types'

export const DEFAULT_LIMIT = 12

type Props = {
  productId: string
  searchCriteria: SearchCriteria
  limit?: number
}

export const useMoreLikeThisQuery = ({
  productId,
  searchCriteria,
  limit = DEFAULT_LIMIT,
}: Props): { products: ProductInfoProduct[]; loading: boolean } => {
  const { data, loading } = useQuery<MoreLikeThisQuery>(MoreLikeThisGQL, {
    variables: {
      productKey: productId,
      filters: {
        ...(searchCriteria.filters.integerFilter && {
          integerFilter: searchCriteria.filters.integerFilter,
        }),
        groupedFacets: searchCriteria.filters.groupedFacets,
      },
      searchTerm: searchCriteria.searchTerm,
      limit,
      ...(searchCriteria.appliedIntents?.length && {
        appliedIntents: searchCriteria.appliedIntents.map(
          ({ intentId, value, ordinal }) => ({
            intentId,
            value,
            ordinal,
          }),
        ),
      }),
    },
  })

  const products = useMemo(() => {
    return data?.moreLikeThis
  }, [data])

  const filteredProducts = useMemo(() => {
    return products ? products.filter(f => f.masterVariant.inStock) : undefined
  }, [products])

  return {
    products: filteredProducts ?? [],
    loading,
  }
}
